import I18n from "../i18n-js/instance";
import { createRoot } from "react-dom/client";
import React from "react";
import { FormsApp } from "@circle-react/apps/FormsApp";
import "stylesheets/third_party.scss";
import "stylesheets/application.scss";

window.I18n = I18n;

window.onload = () => {
  const element = document.getElementById("forms-root");
  if(!element) return;
  const props = JSON.parse(element.dataset.props) || {};
  const root = createRoot(element);
  root.render(React.createElement(FormsApp, props));
};
